export default {
  name: 'MapSidebar',
  mixins: [],
  components: {},
  props: {
    expanded: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {
  },
  methods: {
    onTabClick () {
      this.$emit('toggle')
    }
  }
}
